import { useState, type FormEvent, type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from './AuthProvider';

export function ResetPasswordPage(): ReactNode {
  const auth = useAuth();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  async function submit(event: FormEvent): Promise<void> {
    event.preventDefault();
    await auth.requestPasswordReset(email);
    setSent(true);
  }
  return (
    <main className="auth-page">
      <section className="auth-card">
        <div className="auth-brand">Echo</div>
        <h1>Восстановление пароля</h1>
        {sent ? <p>Ссылка для восстановления отправлена.</p> : (
          <form onSubmit={submit}>
            <label>Email<input type="email" value={email} onChange={(event) => setEmail(event.target.value)} required /></label>
            <button className="button button-primary">Отправить ссылку</button>
          </form>
        )}
        <Link to="/login">Вернуться ко входу</Link>
      </section>
    </main>
  );
}
